import {
  CART_DATA_STALE_AFTER_MS,
  LOCAL_STORAGE_KEY_CART_DATA,
  cartDebug,
  getLocalStorage,
  setLocalStorage
} from "./chunk--chunk-UQVRANVK.vbt.js";

// src/js/helpers/time.js
var hasTimeElapsed = (referenceDateString = (/* @__PURE__ */ new Date()).toISOString(), thresholdTimeMs = 0) => {
  if (!referenceDateString || thresholdTimeMs <= 0) {
    return true;
  }
  const nowMs = Date.now();
  const referenceDateObj = new Date(referenceDateString);
  const referenceDateMs = referenceDateObj.getTime();
  const timeSinceReferenceDateMs = nowMs - referenceDateMs;
  if (timeSinceReferenceDateMs < thresholdTimeMs) {
    return false;
  }
  return true;
};

// src/js/cart/cartData.js
async function getCart() {
  try {
    var response = await fetch(window.Shopify.routes.root + "cart.js", {
      method: "GET"
    });
    if (response.status === 200) {
      const resJson = await response.json();
      return resJson;
    } else {
      throw new Error(response.message);
    }
  } catch (err) {
    console.error(err);
  }
}
function shapeCartData(cart) {
  const items = cart?.items;
  return {
    cartRaw: cart,
    cartItemVariantIds: items.map((item) => item.variant_id?.toString()),
    cartItemVariantQuantityMap: items.reduce((prev, curr) => {
      return {
        ...prev,
        [curr.id]: curr.quantity
      };
    }, {}),
    cartItemsWithGwpProps: items.map((item) => ({
      variant_id: item.variant_id?.toString(),
      properties: {
        _gwp: item.properties?._gwp,
        _gwp_id: item.properties?._gwp_id,
        _gwp_code_value: item.properties?._gwp_code_value,
        _gwp_code_hash: item.properties?._gwp_code_hash,
        _gwp_threshold: parseInt(item.properties?._gwp_threshold) || null
        // _gwp_code_message: item.properties?._gwp_code_message,
      }
    })),
    // return value of user's shopping cart as an integer, in cents;
    cartTotalPrice: cart?.total_price ?? 0
  };
}
function setCartDataLocalStorage(muradCartData) {
  cartDebug("setCartDataLocalStorage: UPDATE CACHED cart");
  const dataWithTimestamp = {
    shapedCartData: muradCartData,
    lastUpdated: (/* @__PURE__ */ new Date()).toISOString()
  };
  setLocalStorage(LOCAL_STORAGE_KEY_CART_DATA, dataWithTimestamp);
}
function getCartDataLocalStorage() {
  return getLocalStorage(LOCAL_STORAGE_KEY_CART_DATA) ?? {};
}
async function getCartData(forceFetch = false) {
  const cartDataLocal = getCartDataLocalStorage();
  const { shapedCartData, lastUpdated } = cartDataLocal;
  const cartDataIsStale = hasTimeElapsed(lastUpdated, CART_DATA_STALE_AFTER_MS);
  if (shapedCartData && !cartDataIsStale && !forceFetch) {
    cartDebug("getCartData: CACHED cart");
    return shapedCartData;
  } else {
    cartDebug("getCartData: FETCH cart");
    cartDebug(cartDataLocal);
    let cartJson = await getCart();
    setCartDataLocalStorage(shapeCartData(cartJson));
    return shapeCartData(cartJson);
  }
}
async function getVariantQuantityInCart(variantId) {
  const cartData = await getCartData();
  return cartData.cartItemVariantQuantityMap[variantId] ?? 0;
}
var cartDataFncs = {
  getVariantQuantityInCart
};

export {
  hasTimeElapsed,
  getCart,
  shapeCartData,
  setCartDataLocalStorage,
  getCartData,
  cartDataFncs
};
